import ResultsServiceModel from '@/models/ResultsServiceModel'

export default class SampleModel extends ResultsServiceModel {
  modelName () {
    return 'samples'
  }

  defaults () {
    return {
      id: null,
      lims_id: null,
      fmis_id: null,
      result_id: null,
      name: null,
      grower: null,
      field: null,
      depth_start: null,
      depth_end: null,
      depth_unit: null,
      depth_unit_id: null,
      feed_type: null,
      animal_fed: null,
      field_texture: null,
      soil_horizon: null,
      index: 0,
      comments: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    }
  }

  mutations () {
    return {
      id: val => this.nullStringMutator(val),
      lims_id: val => this.nullStringMutator(val),
      fmis_id: val => this.nullStringMutator(val),
      result_id: val => this.nullStringMutator(val),
      name: val => this.nullStringMutator(val),
      grower: val => this.nullStringMutator(val),
      field: val => this.nullStringMutator(val),
      depth_start: val => this.nullStringMutator(val),
      depth_end: val => this.nullStringMutator(val),
      depth_unit: val => this.nullStringMutator(val),
      depth_unit_id: val => this.nullStringMutator(val),
      feed_type: val => this.nullStringMutator(val),
      animal_fed: val => this.nullStringMutator(val),
      field_texture: val => this.nullStringMutator(val),
      soil_horizon: val => this.nullStringMutator(val),
      index: val => this.nullStringMutator(val),
      comments: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val)
    }
  }
}
